// Master list of the 6 filter categories
export const EVENT_CATEGORIES = [
  { key: 'food_drink', icon: '🍽️', label: 'Food & Drink' },
  { key: 'nightlife', icon: '🌙', label: 'Nightlife' },
  { key: 'outdoors', icon: '🌿', label: 'Outdoors' },
  { key: 'active', icon: '⚡', label: 'Active' },
  { key: 'shopping', icon: '🛍️', label: 'Shopping' },
  { key: 'entertainment', icon: '🎭', label: 'Entertainment' },
];

// Master category normalization map - maps all detected place types to our 6 filter categories
export const CATEGORY_MAP = {
  // Food & Drink
  restaurant: 'food_drink',
  cafe: 'food_drink',
  bar: 'food_drink',
  pub: 'food_drink',
  fast_food: 'food_drink',
  food_court: 'food_drink',
  ice_cream: 'food_drink',
  bakery: 'food_drink',

  // Nightlife
  nightclub: 'nightlife',
  club: 'nightlife',

  // Outdoors
  park: 'outdoors',
  garden: 'outdoors',
  playground: 'outdoors',
  beach: 'outdoors',
  peak: 'outdoors',
  waterfall: 'outdoors',
  nature: 'outdoors',

  // Active
  sports_centre: 'active',
  fitness_centre: 'active',
  gym: 'active',
  stadium: 'active',
  swimming_pool: 'active',
  pitch: 'active',
  sports: 'active',

  // Shopping
  supermarket: 'shopping',
  convenience: 'shopping',
  mall: 'shopping',
  marketplace: 'shopping',
  shop: 'shopping',
  clothes: 'shopping',

  // Entertainment (default for everything else)
  museum: 'entertainment',
  gallery: 'entertainment',
  theatre: 'entertainment',
  cinema: 'entertainment',
  library: 'entertainment',
  attraction: 'entertainment',
  hotel: 'entertainment',
  monument: 'entertainment',
  castle: 'entertainment',
  viewpoint: 'entertainment',
  bank: 'entertainment',
  atm: 'entertainment',
  pharmacy: 'entertainment',
  hospital: 'entertainment',
  police: 'entertainment',
  post_office: 'entertainment',
  gas_station: 'entertainment',
  fuel: 'entertainment',
  parking: 'entertainment',

  // Default
  place: 'entertainment',
  default: 'entertainment',
};

// Normalize any detected type to one of our 6 filter categories
export const normalizeCategory = (type) => {
  return CATEGORY_MAP[type] || 'entertainment';
};